export default __webpack_public_path__ + "static/media/Bandeau 25 HD.4acd473e.jpg";